module.exports = __webpack_public_path__ + "ptc_momoro_I2.9a4419dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_I2.jpg
// module id = t/Cv
// module chunks = 0